module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_5012.f9462c9c.png";